import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { StateModel } from 'src/models';

const stateAdapter: AdapterFunc<GQL.StateDbModel, StateModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default stateAdapter;
